function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import OtpModal from "../OtpModal";

/**
 * AccountClosureModal - Presentational modal for initiating account closure.
 *
 * Flow:
 * 1. Warning Dialog: Displays grace period notice, consequences of deletion,
 *    and an optional reason selection.
 * 2. OTP Verification: Triggers the shared OtpModal to verify identity.
 *
 * Props:
 * - open: boolean controlling visibility
 * - onClose: () => void, called when user dismisses the modal
 * - graceDays: number (default: 7), grace period in days
 * - onRequestOtp: async () => void, sends closure OTP
 * - onConfirmClose: async (otp, reason) => void, submits closure with OTP and reason
 * - requestOtpLoading: boolean, loading state for OTP request
 * - confirmLoading: boolean, loading state for closure submission
 * - errorMessage: string, external error message to display
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var AccountClosureModal = function AccountClosureModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    _ref$graceDays = _ref.graceDays,
    graceDays = _ref$graceDays === void 0 ? 7 : _ref$graceDays,
    onRequestOtp = _ref.onRequestOtp,
    onConfirmClose = _ref.onConfirmClose,
    _ref$requestOtpLoadin = _ref.requestOtpLoading,
    requestOtpLoading = _ref$requestOtpLoadin === void 0 ? false : _ref$requestOtpLoadin,
    _ref$confirmLoading = _ref.confirmLoading,
    confirmLoading = _ref$confirmLoading === void 0 ? false : _ref$confirmLoading,
    errorMessage = _ref.errorMessage;
  var _useState = useState("WARN"),
    _useState2 = _slicedToArray(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1]; // "WARN" | "OTP"
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    reason = _useState4[0],
    setReason = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    localError = _useState6[0],
    setLocalError = _useState6[1];
  if (!open) return null;
  var handleReset = function handleReset() {
    setStep("WARN");
    setReason("");
    setLocalError("");
    onClose();
  };
  var handleRequestOtp = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            setLocalError("");
            _context.p = 1;
            _context.n = 2;
            return onRequestOtp();
          case 2:
            setStep("OTP");
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            setLocalError((_t === null || _t === void 0 ? void 0 : _t.message) || "Failed to send OTP. Please try again.");
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function handleRequestOtp() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleVerifyOtp = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(otp) {
      var _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            setLocalError("");
            _context2.p = 1;
            _context2.n = 2;
            return onConfirmClose(otp, reason);
          case 2:
            handleReset();
            _context2.n = 4;
            break;
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            setLocalError((_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || "Closure confirmation failed. Please try again.");
          case 4:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function handleVerifyOtp(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  if (step === "OTP") {
    return /*#__PURE__*/_jsx(OtpModal, {
      open: true,
      onClose: function onClose() {
        return setStep("WARN");
      },
      title: "Verify Account Closure",
      description: "Enter the OTP sent to your registered mobile/email to confirm account closure.",
      onResend: onRequestOtp,
      onVerify: handleVerifyOtp,
      resendLoading: requestOtpLoading,
      verifyLoading: confirmLoading,
      errorMessage: localError || errorMessage
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4",
    children: /*#__PURE__*/_jsxs("div", {
      className: "w-full max-w-md rounded-lg bg-white p-6 shadow-xl",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-between border-b pb-3",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "text-xl font-semibold text-red-600",
          children: "Close Account"
        }), /*#__PURE__*/_jsx("button", {
          onClick: handleReset,
          className: "text-gray-400 hover:text-gray-600 text-xl font-bold",
          "aria-label": "Close",
          children: "\xD7"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "mt-4 space-y-3 text-sm text-gray-600",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "rounded-md bg-amber-50 p-3 text-amber-800 border border-amber-200",
          children: [/*#__PURE__*/_jsx("p", {
            className: "font-semibold",
            children: "\u26A0\uFE0F Important Notice"
          }), /*#__PURE__*/_jsxs("p", {
            className: "mt-1",
            children: ["Your account will enter a ", /*#__PURE__*/_jsxs("strong", {
              children: [graceDays, "-day grace period"]
            }), ". During this time, your profile will be deactivated, but you can cancel closure anytime before permanent deletion."]
          })]
        }), /*#__PURE__*/_jsxs("ul", {
          className: "list-disc pl-5 space-y-1 text-gray-700",
          children: [/*#__PURE__*/_jsx("li", {
            children: "Your active sessions will be logged out immediately."
          }), /*#__PURE__*/_jsxs("li", {
            children: ["All personal details will be permanently scrubbed after ", graceDays, " days."]
          }), /*#__PURE__*/_jsx("li", {
            children: "Saved preferences and rewards will be deleted."
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "pt-2",
          children: [/*#__PURE__*/_jsx("label", {
            className: "block text-xs font-medium text-gray-700 mb-1",
            children: "Reason for closing (optional):"
          }), /*#__PURE__*/_jsxs("select", {
            value: reason,
            onChange: function onChange(e) {
              return setReason(e.target.value);
            },
            className: "w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-red-500 focus:outline-none",
            children: [/*#__PURE__*/_jsx("option", {
              value: "",
              children: "Select a reason..."
            }), /*#__PURE__*/_jsx("option", {
              value: "NO_LONGER_NEEDED",
              children: "I no longer need this account"
            }), /*#__PURE__*/_jsx("option", {
              value: "PRIVACY_CONCERNS",
              children: "Privacy or data concerns"
            }), /*#__PURE__*/_jsx("option", {
              value: "DUPLICATE_ACCOUNT",
              children: "Created a duplicate account"
            }), /*#__PURE__*/_jsx("option", {
              value: "OTHER",
              children: "Other reason"
            })]
          })]
        })]
      }), (localError || errorMessage) && /*#__PURE__*/_jsx("p", {
        className: "mt-3 text-sm text-red-600",
        children: localError || errorMessage
      }), /*#__PURE__*/_jsxs("div", {
        className: "mt-6 flex items-center justify-end gap-3",
        children: [/*#__PURE__*/_jsx("button", {
          onClick: handleReset,
          className: "rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50",
          children: "Cancel"
        }), /*#__PURE__*/_jsx("button", {
          onClick: handleRequestOtp,
          disabled: requestOtpLoading,
          className: "rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed",
          children: requestOtpLoading ? "Sending OTP..." : "Proceed to Close"
        })]
      })]
    })
  });
};
export default AccountClosureModal;